import React from 'react';
import { Box, Card, CardContent, Typography, Avatar, Grid, Divider, Button } from '@mui/material';
import { PageContainer, PageTitle } from '../../components/Common';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthProvider';

const Profile = () => {
    const { t } = useLanguage();
    const { keycloakInstance } = useAuth();

    const handleChangePassword = () => {
        keycloakInstance?.login({ action: 'UPDATE_PASSWORD', redirectUri: window.location.href });
    };

    const getUserInitials = () => {
        const firstName = keycloakInstance?.tokenParsed?.given_name || '';
        const lastName = keycloakInstance?.tokenParsed?.family_name || '';
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || '?';
    };

    return (
        <PageContainer>
            <PageTitle>{t('pages.profile.title')}</PageTitle>
            
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Avatar
                            sx={{
                                width: 80,
                                height: 80,
                                mr: 3,
                                bgcolor: '#556ee6',
                                fontSize: '2rem'
                            }}
                        >
                            {getUserInitials()}
                        </Avatar>
                        <Box>
                            <Typography variant="h5" gutterBottom>
                                {`${keycloakInstance?.tokenParsed?.given_name || ''} ${keycloakInstance?.tokenParsed?.family_name || ''}`.trim() || t('pages.profile.noName')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {keycloakInstance?.tokenParsed?.email || t('pages.profile.noEmail')}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                {t('pages.profile.username')}
                            </Typography>
                            <Typography variant="body1">
                                {keycloakInstance?.tokenParsed?.preferred_username || '-'}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                {t('pages.profile.email')}
                            </Typography>
                            <Typography variant="body1">
                                {keycloakInstance?.tokenParsed?.email || '-'}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                {t('pages.profile.firstName')}
                            </Typography>
                            <Typography variant="body1">
                                {keycloakInstance?.tokenParsed?.given_name || '-'}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                {t('pages.profile.lastName')}
                            </Typography>
                            <Typography variant="body1">
                                {keycloakInstance?.tokenParsed?.family_name || '-'}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 3 }} />

                    <Button variant="outlined" onClick={handleChangePassword}>
                        {t('pages.profile.changePassword')}
                    </Button>
                </CardContent>
            </Card>
        </PageContainer>
    );
};

export default Profile;
